import { useState } from "react";
import { Button, ModalDelete } from "expano-components";
import useDelete from "hooks/useDelete";

import AddPlatformTaxonModal from "./components/AddPlatformTaxonModal";

const PlatformTaxonItem = ({
  id,
  platform_id,
  product_group_id,
  platform_taxon,
  refetch,
}) => {
  const [is_open_add_platform_taxon_modal, handleOpenPlatformTaxonModal] =
    useState(false);
  const [is_open_delete_modal, handleOpenDeleteModal] = useState(false);

  const { is_deleting, _delete } = useDelete({
    path: `/platform_taxon_product_groups/${id}`,
    success_message: "Kategoria została usunięta",
    onSuccess: () => [refetch(), handleOpenDeleteModal()],
  });

  const ancestry = platform_taxon?.path_names?.split(">");

  if (!platform_taxon) {
    return (
      <>
        {is_open_add_platform_taxon_modal && (
          <AddPlatformTaxonModal
            platform_id={platform_id}
            product_group_id={product_group_id}
            refetch={refetch}
            handleClose={() => handleOpenPlatformTaxonModal(false)}
          />
        )}
        <Button
          type="add"
          text="Dodaj kategorię"
          onClick={() => handleOpenPlatformTaxonModal(true)}
        />
      </>
    );
  }
  return (
    <div className="platform-taxons-list__item">
      {is_open_delete_modal && (
        <ModalDelete
          name={`kategorię ${platform_taxon?.name}?`}
          handleDelete={_delete}
          handleClose={() => handleOpenDeleteModal(false)}
        />
      )}
      <div className="box-text">
        <p className="category-label">
          {platform_taxon?.name} [{platform_taxon?.external_id}]
        </p>{" "}
        <ul className="taxons-list">
          {ancestry?.map((item, index) => (
            <li
              className={`taxons-list__item ${
                index === ancestry.length - 1 ? "current" : ""
              }`}
            >
              {item}
            </li>
          ))}
        </ul>
      </div>
      <Button
        type="delete"
        text="Usuń"
        disabled={is_deleting}
        onClick={() => handleOpenDeleteModal(true)}
      />
    </div>
  );
};

export default PlatformTaxonItem;
